import * as React from "react";
import {Fragment} from "react";
import LeadBDPChangeNotification from "../../../model/notification/assignee/LeadBDPChangeNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: LeadBDPChangeNotification
}

/**
 * BDP change notification toast body.
 */
const NotificationBDPChangeBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Lead {props.notification.data.getLeadReferenceNumber()}</div>
			<div className={"toast-body"}>
				Business Development Partner changed from <b>{props.notification.displayPreviousAssignee()} </b>
				to <b>{props.notification.displayCurrentAssignee()}</b>
			</div>
		</Fragment>
	);
};

export default NotificationBDPChangeBody;